import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment";
import '../../../node_modules/trumbowyg/dist/trumbowyg.min.js';
import '../../../node_modules/trumbowyg/dist/plugins/base64/trumbowyg.base64.min.js';
import '../../../node_modules/trumbowyg/dist/langs/de.min.js';
import './editorIcons';
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import { Utils } from "../../utils";
import { Filter } from "../case/caseentryoverview";

class ComposeViewModel {
    from = ko.observable({ EMail_Address: "" } as any);
    to = ko.observable("");
    cc = ko.observable("");
    subject = ko.observable("");
    caseId = ko.observable("");
    records = ko.observableArray([]);

    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    pickFrom = async () => {
        let inboxes = (await RNSAPI.getAllInboxes()).Payload.Accounts;
        this.pickGeneric("E-Mail-Adressen", ['EMail_Address'], ['E-Mail'], inboxes);
        this.modalHandleSelection((selectedObject) => this.from(selectedObject()));
        $('#modal').modal('show');
    };

    pickCase = async () => {
        let cases = (await RNSAPI.getCases()).Payload.Cases;
        this.pickGeneric("Akten", ['Registernummer', 'Rubrum'], ['Registernummer', 'Rubrum'], cases);
        this.modalHandleSelection((selectedObject) => this.caseId(selectedObject().Registernummer));
        $('#modal').modal('show');
    };

    pickRecord = async () => {
        let records = (await RNSAPI.getCaseEntriesForId(this.caseId())).Payload.Records;
        let sortedRecords = records.sort((a, b) => {
            let dateA = new Date(a.LastChange || a.DocumentDate || a.RecordDate);
            let dateB = new Date(b.LastChange || b.DocumentDate || b.RecordDate);
            if (dateA < dateB) return 1;
            else if (dateA > dateB) return -1;
            else return 0
        });
        let mappedRecords = sortedRecords.map(record => {
            record.DocumentDate = (new Date(record.LastChange || record.DocumentDate || record.RecordDate)).toLocaleDateString();
            return record;
        });
        this.pickGeneric("EAkten", ['DocumentDate', 'Subject'], ['Datum', 'Betreff'], mappedRecords);
        this.modalHandleSelection((selectedObject) => this.records.push(selectedObject()));
        $('#modal').modal('show');
    };

    deleteRecord = (id: string) => {
        this.records(this.records().filter(record => record.Id !== id));
    };

    public sendMail = async () => {
        let html = ($('#trumbowyg') as any).trumbowyg('html');
        let text = $(html).text();
        let mail = {
            To: this.to(),
            Ccc: this.cc(),
            Bcc: "",
            Subject: this.subject(),
            From: this.from().EMail_Address,
            AccountID: this.from().EMailAccount_ID,
            BodyHtml: html,
            BodyText: text,
            ECaseRecordIDs: this.records().map(record => record.Id)
        };

        if (!Utils.checkErrors(["to", "subject"], this, "", [Utils.checkString])) return;
        if (!Utils.checkErrors(["from"], this, "",
            [(from) => Utils.checkString(from.EMail_Address),
            (from) => Utils.checkEmail(from.EMail_Address)])) return;

        try {
            let result = (await RNSAPI.sendMail(mail));
            if (result.Type === "SendSuccessful") {
                alert("Mail erfolgreich versendet.");
            } else {
                alert("Fehler beim Senden!");
            }
        } catch (e) {
            console.log(e);
            alert("Fehler beim Senden!");
        }
    };


    async loadECase(id: string) {
        let result = (await RNSAPI.getCaseEntry(id));
        if (result.Type === 'IdFound') {
            this.records.push(result.Payload.Record);
        }
    }

    constructor(params: any) {
        if (params && params.caseId) {
            this.caseId(params.caseId);
        }

        if (params && params.eCaseRecordId) {
            this.loadECase(params.eCaseRecordId);
        }

        ($('#trumbowyg') as any).trumbowyg({
            lang: "de",
            resetCss: true,
            btnsDef: {
                // Create a new dropdown
                image: {
                    dropdown: ['insertImage', 'base64'],
                    ico: 'insertImage'
                }
            },
            // Redefine the button pane
            btns: [
                ['viewHTML'],
                ['formatting'],
                ['strong', 'em', 'del'],
                ['superscript', 'subscript'],
                ['link'],
                ['image'], // Our fresh created dropdown
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                ['unorderedList', 'orderedList'],
                ['horizontalRule'],
                ['removeformat'],
                ['fullscreen']
            ]
        });
    }
}

let html = fs.readFileSync(__dirname + '/compose.html', 'utf8');

ko.components.register("compose-view", {
    viewModel: ComposeViewModel,
    template: html
});